import { Col, message, Row } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import {
  ReplacementTransportOptionFormCard,
  ReplacementTransportOptionInputDto,
} from "./components/ReplacementTransportOptionFormCard";
import {
  fetchReplacementTransportOptionById,
  updateReplacementTransportOptionById,
} from "../../../../lib/api/resources/replacementTransports";

export const ReplacementTransportOptionEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const replacementTransportOptionQuery = useQuery({
    queryKey: ["replacementTransportOption", id],
    queryFn: async () => fetchReplacementTransportOptionById(id),
  });

  const updateReplacementTransportOptionMutation = useMutation({
    mutationFn: (data: ReplacementTransportOptionInputDto) =>
      updateReplacementTransportOptionById(id, data),
    onSuccess: () => {
      navigate(`/replacement-transport/options/${id}`);
      message.success("Vervangend vervoer optie succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de vervangend vervoer optie",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <ReplacementTransportOptionFormCard
          initialValues={replacementTransportOptionQuery.data}
          loading={replacementTransportOptionQuery.isLoading}
          mutation={updateReplacementTransportOptionMutation}
          title="Vervangend vervoer optie bewerken"
          buttonText="Bewerken"
        />
      </Col>
    </Row>
  );
};
